import { useQuery } from '@tanstack/react-query';
import useUser from '../global/useUser';
import useBusiness from '../businesses/useBusiness';
import { getBusinessFlashbook } from '../../services/flashbooks';
import { userHasAccessToShopFlash } from '../../helpers/flashbooks';

function useGetBusinessFlashbook({
  enabled = true,
}: { enabled?: boolean } = {}) {
  const { user } = useUser();
  const { business } = useBusiness();
  const businessId = business?.id;

  return useQuery({
    queryKey: ['flashbook', 'business', businessId],
    enabled:
      !!user && !!businessId && userHasAccessToShopFlash(user) && enabled,
    queryFn: () => getBusinessFlashbook(businessId!),
  });
}

export default useGetBusinessFlashbook;
